import { ReactNode } from "react"

import { Space } from "antd"
import { DefaultTooltipContent, TooltipProps  } from "recharts"
import { NameType, ValueType } from "recharts/types/component/DefaultTooltipContent"

import { BaseDiagramAnalytics } from "@/types/IAnalytics"

export const payloadLabelDelimeter = "->"

type MyTooltipState = TooltipProps <ValueType, NameType>
                      & {filtersText: string | string[] | undefined | null}

export const payloadWithdelimeterFormatter = (value: string): ReactNode => {
  if (!value || !(value as string)) {
    return
  }
  const split = value.split(payloadLabelDelimeter)
  if (split.length === 2) {
    return <Space>
      {split.map((val, index) => {
        const color = index > 0 ? "#999" : "#666"
        const size = "1.0em"

        return <span key={crypto.randomUUID()} style={{ fontSize: size, color: color }}>{val}</span>
      })}
    </Space>
  }
  return split[0]
}

export const CustomTooltipWithFilterInfo = (tooltipProps: MyTooltipState) => {
   const { active, payload, filtersText } = tooltipProps

  if (active && payload && payload.length) {
    const newPayload: any[] = [
      ...payload
    ]

    if (filtersText) {
      if (Array.isArray(filtersText) && filtersText.length > 1) {
        filtersText.forEach((f, index) => {
          newPayload.push({
            name: `Фильтр ${index+1}`,
            value: f,
            color: "grey"
          })
        })
      }
      else {
        newPayload.push({
          name: "Фильтры",
          value: Array.isArray(filtersText) ? filtersText[0] : filtersText,
          color: "grey"
        })
      }
    }

    if (payload[0] && payload[0].payload && (payload[0].payload as BaseDiagramAnalytics).filterText) {
      newPayload.push({
        name: "Фильтры",
        value: (payload[0].payload as BaseDiagramAnalytics).filterText,
        color: "grey"
      })
    }

    return <DefaultTooltipContent {...tooltipProps} payload={newPayload} labelFormatter={payloadWithdelimeterFormatter}/>
  }

  return null
}

export const CustomizedAxisTickInTwoLines = ({ x, y, payload }: any) => {
  const split = (payload.value as string).split(payloadLabelDelimeter)
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="middle"
        fill="#666"
      >
        {split.map((val, index) => {
          const color = index > 0 ? "#999" : "#666"
          const size = index > 0 ? "0.8em" : "1.0em"

          return <tspan key={crypto.randomUUID()} x={0} dy={size} fill={color}>{val}</tspan>
        })}
      </text>
    </g>
  )
}
